import axios from '../../library/modules/axios'
// 获取医生列表
export function getDoctorList(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/doctors/query',
    method: 'post',
    data
  })
}
// 获取医生列表 云大医院
// 根据科室 ID 或院区id获取特需专家医生列表数据
export function getDoctorListYunDa(params) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/departments/doctors/special-needs',
    method: 'get',
    params
  })
}
// 医生详情
export function getDoctorDetail(id) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/doctors/${id}`,
    method: 'get'
  })
}

// 获取医生排班
export function getDoctorSchedule(id) {
  return axios.service({
    url: `/apis/v1/schedule/schedules/client/doctor/schedules`,
    method: 'get',
    params: {
      doctor_id: id
    }
  })
}

// 获取排班列表
export function getDoctorScheduleList(params) {
  return axios.service({
    url: `/apis/v1/schedule/schedules/client`,
    method: 'get',
    params
  })
}
// 获取排班时段
export function getDoctorScheduleTime(params) {
  return axios.service({
    url: `/apis/v1/schedule/schedule-time-parts/client`,
    method: 'get',
    params
  })
}
// 获取排班医生列表
export function getDoctorScheduleDoctor(params) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/departments/doctors`,
    method: 'get',
    params
  })
}
// 871899-昆华挂号日期
export function getRegistrationDate(department_code) {
  return axios.axiosBaseApi({
    url: `/hos/registration/getRegistrationDate?department_code=${department_code}`,
    method: 'get'
  })
}
// 871899-昆华
export function getDoctorRegistrationDate(department_code,doc_code) {
  return axios.axiosBaseApi({
    url: `/hos/registration/getDoctorRegistrationDate?department_code=${department_code}&doctor_code=${doc_code}`,
    method: 'get'
  })
}
//871899-昆华根据挂号日期查询医生
export function getRegistrationDoctor(department_code = '9%2308', registration_date = '2025-01-09', department_id = '251946') {
  return axios.axiosBaseApi({
    url: `/hos/registration/getRegistrationDoctor?department_code=${department_code}&registration_date=${registration_date}&department_id=${department_id}`,
    method: 'get'
  })
}
// 获取医生团队
export function getDoctorSteam(id) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/doctors/${id}/ask-services`,
    method: 'get'
  })
}
// 查询医生所有科室排班
export function getDoctorAllSchedule(params) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/doctors/schduled-departments`,
    method: 'get',
    params
  })
}
// 查询号满推荐医生列表
export function getRecommendDoctors(params) {
  return axios.service({
    url: `/apis/v1/tenant/customer/source-recommend-config/recommend-doctors`,
    method: 'get',
    params
  })
}
// 获取最近预约医生列表
// {
//   hospital_code: '',
//   user_id: ''
// }
export function getRecentDoctors(params) {
  return axios.service({
    url: `/apis/v1/schedule/schedules/client/doctor_list`,
    method: 'get',
    params
  })
}
